interface SpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    /** If true, inherits color from parent instead of using accent color */
    inheritColor?: boolean;
}

/**
 * Reusable loading spinner component.
 */
export function Spinner({ size = 'md', className, inheritColor }: SpinnerProps) {
    const sizeClasses = {
        sm: 'h-4 w-4',
        md: 'h-5 w-5',
        lg: 'h-8 w-8',
    };

    const colorClasses = inheritColor ? '' : 'text-accent dark:text-primary-light';

    return (
        <svg
            className={`animate-spin ${sizeClasses[size]} ${colorClasses} ${className ?? ''}`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            />
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
        </svg>
    );
}
